/* =====================================================================
   LATAKAN - reviews.js  (page « Avis clients », avis REELS)
   - Produit lu via ?product=<handle>
   - Agregat + cartes : fetch /products/<handle>?view=reviewsjson
     (templates/product.reviewsjson.liquid, seuls les avis ACTIFS remontent)
   - Filtres (note / taille) + tris (recent / utile / mieux notes) sur les cartes rendues
   - Etat vide si count=0 : « Sois le premier a donner ton avis sur ce maillot. »
   - Formulaire : POST JSON vers le worker (data-worker-url) avec jeton Turnstile.
     Succes -> « Merci, ton avis sera publie apres moderation. » (avis cree en DRAFT)
     Pas de worker_url -> envoi desactive proprement (« bientot disponible »).
   ===================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('.rv');
  if (!root) return;

  var workerUrl = (root.getAttribute('data-worker-url') || '').trim();
  var sitekey = (root.getAttribute('data-turnstile-sitekey') || '').trim();

  var params = new URLSearchParams(window.location.search);
  var handle = (params.get('product') || '').trim();

  /* ---------- references DOM ---------- */
  var nameNodes = root.querySelectorAll('[data-rv-product]');
  var head = root.querySelector('[data-rv-producthead]');
  var prodImg = root.querySelector('[data-rv-prodimg]');
  var prodLink = root.querySelector('[data-rv-prodlink]');

  var summary = root.querySelector('[data-rv-summary]');
  var emptyState = root.querySelector('[data-rv-empty]');
  var toolbar = root.querySelector('[data-rv-toolbar]');
  var filterToggle = root.querySelector('[data-rv-filtertoggle]');
  var filterPanel = root.querySelector('[data-rv-filterpanel]');
  var filterCount = root.querySelector('[data-rv-filtercount]');
  var activeFilters = root.querySelector('[data-rv-activefilters]');
  var list = root.querySelector('[data-rv-list]');
  var noRes = root.querySelector('[data-rv-nores]');
  var moreWrap = root.querySelector('[data-rv-morewrap]');
  var moreBtn = root.querySelector('[data-rv-more]');

  /* libelles lisibles des filtres de note (pour les puces actives) */
  var RATING_LABELS = { '5': '5 étoiles', '4': '4 étoiles', '3': '3 étoiles', '2': '2 étoiles', '1': '1 étoile' };

  var PAGE = 5; // cartes visibles avant « Charger plus »

  /* ---------- utilitaires ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function frNum(n) {
    return String(n).replace('.', ',');
  }
  var STAR = '<svg viewBox="0 0 24 24"><path d="M12 3.5l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4L4.2 9.2l5.4-.8Z"/></svg>';
  var STAR_EMPTY = '<svg viewBox="0 0 24 24" class="is-empty"><path d="M12 3.5l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4L4.2 9.2l5.4-.8Z"/></svg>';
  function starsHtml(rating) {
    var out = '';
    for (var i = 1; i <= 5; i++) out += i <= rating ? STAR : STAR_EMPTY;
    return out;
  }
  function frDate(iso) {
    if (!iso) return '';
    var parts = String(iso).split('-');
    if (parts.length !== 3) return esc(iso);
    var mois = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    var m = parseInt(parts[1], 10) - 1;
    var d = parseInt(parts[2], 10);
    if (isNaN(m) || isNaN(d) || m < 0 || m > 11) return esc(iso);
    return d + ' ' + mois[m] + ' ' + parts[0];
  }

  /* ---------- etat ---------- */
  var data = null;
  var state = { rating: '', size: '', sort: 'recent', revealed: false };

  /* ---------- votes « Utile » persistes (localStorage, par avis, anti double-vote) ---------- */
  var VOTES = (function () { try { return JSON.parse(localStorage.getItem('latakan_rv_votes') || '{}') || {}; } catch (e) { return {}; } })();
  function saveVotes() { try { localStorage.setItem('latakan_rv_votes', JSON.stringify(VOTES)); } catch (e) {} }
  function voteKey(r) { return (handle || '') + '|' + (r.author || '') + '|' + (r.date || '') + '|' + (parseInt(r.helpful, 10) || 0); }

  /* ---------- nom + vignette du produit ---------- */
  function setName(name) {
    nameNodes.forEach(function (n) { n.textContent = name; });
  }
  function fetchProductMeta() {
    if (!handle) return Promise.resolve();
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        if (p.title) setName(p.title);
        if (head) {
          var src = p.featured_image || (p.images && p.images[0]) || '';
          if (src && prodImg) {
            if (src.indexOf('//') === 0) src = window.location.protocol + src;
            prodImg.src = src;
            prodImg.alt = p.title || '';
          } else if (prodImg) {
            var thumb = prodImg.closest('.rv__prodthumb');
            if (thumb) thumb.style.display = 'none';
          }
          if (prodLink && p.url) { prodLink.href = p.url; prodLink.removeAttribute('aria-hidden'); prodLink.removeAttribute('tabindex'); }
          head.hidden = false;
        }
      })
      .catch(function () { /* repli silencieux : « ce produit » reste affiche */ });
  }

  /* ---------- chargement des avis (vue JSON) ---------- */
  function fetchReviews() {
    setTimeout(function () { if (root) root.classList.add('is-rvready'); }, 3000);
    if (!handle) { renderEmpty(); return; }
    fetch('/products/' + encodeURIComponent(handle) + '?view=reviewsjson')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        data = json;
        if (!json || !json.count || !(json.reviews && json.reviews.length)) {
          renderEmpty();
          return;
        }
        if (json.title) setName(json.title);
        renderSummary(json);
        renderList();
      })
      .catch(function () { renderEmpty(); });
  }

  /* ---------- etat vide ---------- */
  function renderEmpty() {
    if (root) root.classList.add('is-rvready');
    if (summary) summary.hidden = true;
    if (toolbar) toolbar.hidden = true;
    if (filterPanel) { filterPanel.hidden = true; closeFilterPanel(); }
    if (activeFilters) activeFilters.hidden = true;
    if (moreWrap) moreWrap.hidden = true;
    if (noRes) noRes.hidden = true;
    if (list) list.innerHTML = '';
    if (emptyState) emptyState.hidden = false;
  }

  /* ---------- resume (note, count, distribution, recommend) ---------- */
  function renderSummary(json) {
    if (root) root.classList.add('is-rvready');
    if (emptyState) emptyState.hidden = true;
    if (summary) summary.hidden = false;
    if (toolbar) toolbar.hidden = false;

    var avg = root.querySelector('[data-rv-avg]');
    if (avg) avg.textContent = frNum(json.rating);

    var avgStars = root.querySelector('[data-rv-avgstars]');
    if (avgStars) {
      avgStars.innerHTML = starsHtml(Math.round(json.rating));
      avgStars.setAttribute('aria-label', frNum(json.rating) + ' sur 5');
    }

    var verified = root.querySelector('[data-rv-verifiedlabel]');
    if (verified) verified.textContent = 'Basé sur ' + json.count + (json.count > 1 ? ' avis vérifiés' : ' avis vérifié');

    var reco = root.querySelector('[data-rv-recommend]');
    if (reco) reco.textContent = json.recommend;

    var trustAvg = root.querySelector('[data-rv-trustavg]');
    if (trustAvg) trustAvg.textContent = frNum(json.rating) + '/5 sur ' + json.count + (json.count > 1 ? ' avis' : ' avis');

    var dist = json.distribution || {};
    [5, 4, 3, 2, 1].forEach(function (k) {
      var rowN = dist[k] || 0;
      var pct = json.count ? Math.round((rowN / json.count) * 100) : 0;
      var row = root.querySelector('[data-rv-distrow="' + k + '"]');
      if (!row) return;
      var fill = row.querySelector('[data-rv-barfill]');
      var pctEl = row.querySelector('[data-rv-distpct]');
      var nEl = row.querySelector('[data-rv-distn]');
      if (fill) fill.style.width = pct + '%';
      if (pctEl) pctEl.textContent = pct + '%';
      if (nEl) nEl.textContent = rowN;
    });
  }

  /* ---------- liste filtree + triee ---------- */
  function visibleReviews() {
    var arr = (data && data.reviews ? data.reviews : []).slice();
    arr = arr.filter(function (r) {
      if (state.rating && String(r.rating) !== state.rating) return false;
      if (state.size && (r.size || '') !== state.size) return false;
      return true;
    });
    arr.sort(function (a, b) {
      if (state.sort === 'helpful') return (b.helpful || 0) - (a.helpful || 0);
      if (state.sort === 'top') return (b.rating || 0) - (a.rating || 0) || (b.date || '').localeCompare(a.date || '');
      return (b.date || '').localeCompare(a.date || ''); // recent = date decroissante
    });
    return arr;
  }

  function cardHtml(r) {
    var badge = r.verified
      ? '<span class="rv__vbadge"><svg viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg> Achat vérifié</span>'
      : '';
    var sizeMeta = r.size
      ? '<span class="rv__size">Taille achetée : <b>' + esc(r.size) + '</b></span>'
      : '';
    var titleHtml = r.title ? '<h2 class="rv__title">' + esc(r.title) + '</h2>' : '';
    var vk = voteKey(r);
    var voted = !!VOTES[vk];
    var baseH = parseInt(r.helpful, 10) || 0;
    var hc = baseH + (voted ? 1 : 0);
    return '' +
      '<article class="rv__card" data-stars="' + esc(r.rating) + '" data-size="' + esc(r.size || '') + '" data-helpful="' + esc(r.helpful || 0) + '">' +
        '<div class="rv__meta">' +
          '<div class="rv__metastars">' +
            '<span class="rv__stars" role="img" aria-label="' + esc(r.rating) + ' sur 5">' + starsHtml(r.rating) + '</span>' +
            '<span class="rv__ratingnum">' + esc(r.rating) + '/5</span>' +
          '</div>' +
          '<span class="rv__author">' + esc(r.author || 'Client vérifié') + '</span>' +
          badge +
          sizeMeta +
        '</div>' +
        '<div class="rv__body">' +
          '<div class="rv__bodytop">' + titleHtml + '</div>' +
          '<p class="rv__text">' + esc(r.body || '') + '</p>' +
          '<div class="rv__foot">' +
            '<span class="rv__date">' + esc(frDate(r.date)) + '</span>' +
            '<span class="rv__helpful">Utile ? ' +
              '<button class="rv__vote' + (voted ? ' is-on' : '') + '" type="button" data-rv-up data-vk="' + esc(vk) + '" data-base="' + baseH + '" aria-pressed="' + (voted ? 'true' : 'false') + '"><svg viewBox="0 0 24 24"><path d="M7 11v9H4a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3Z"/><path d="M7 11l4.5-7.5A2 2 0 0 1 15 4.7L14 9h5a2 2 0 0 1 2 2.3l-1.2 7A2 2 0 0 1 17.8 20H7"/></svg> <b>' + hc + '</b></button>' +
            '</span>' +
          '</div>' +
        '</div>' +
      '</article>';
  }

  function renderList() {
    if (!list) return;
    var arr = visibleReviews();
    var hasFilter = !!(state.rating || state.size);
    var shown = (state.revealed || hasFilter) ? arr : arr.slice(0, PAGE);

    list.innerHTML = shown.map(cardHtml).join('');

    if (noRes) noRes.hidden = arr.length !== 0;
    if (moreWrap) moreWrap.hidden = !(!state.revealed && !hasFilter && arr.length > PAGE);

    syncChips();
    syncFilterCount();
    if (activeFilters) activeFilters.hidden = !hasFilter;
  }

  /* ---------- puces de filtres actifs ---------- */
  function syncChips() {
    var ratingChip = root.querySelector('[data-rv-chip="rating"]');
    if (ratingChip) {
      if (state.rating) {
        var rl = ratingChip.querySelector('[data-rv-chiplabel]');
        if (rl) rl.textContent = RATING_LABELS[state.rating] || state.rating;
        ratingChip.hidden = false;
      } else {
        ratingChip.hidden = true;
      }
    }
    var sizeChip = root.querySelector('[data-rv-chip="size"]');
    if (sizeChip) {
      if (state.size) {
        var sl = sizeChip.querySelector('[data-rv-chiplabel]');
        if (sl) sl.textContent = state.size;
        sizeChip.hidden = false;
      } else {
        sizeChip.hidden = true;
      }
    }
  }

  /* ---------- badge « nombre de filtres actifs » sur le bouton Filtrer ---------- */
  function syncFilterCount() {
    if (!filterCount) return;
    var n = (state.rating ? 1 : 0) + (state.size ? 1 : 0);
    if (n > 0) {
      filterCount.textContent = n;
      filterCount.hidden = false;
      if (filterToggle) filterToggle.classList.add('is-active');
    } else {
      filterCount.hidden = true;
      if (filterToggle) filterToggle.classList.remove('is-active');
    }
  }

  /* ---------- ecouteurs filtres / tri ---------- */
  root.querySelectorAll('[data-rv-filter]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      state[sel.getAttribute('data-rv-filter')] = sel.value;
      state.revealed = false;
      renderList();
    });
  });
  var sortSel = root.querySelector('[data-rv-sort]');
  if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; renderList(); });

  /* ---------- bouton « Filtrer » : plie / deplie le panneau de filtres ----------
     Le panneau reste TOUJOURS dans le flux (pas de display:none, qui casse la transition).
     Replie = max-height:0 + visibility:hidden (donc hors tab order, bon pour l'a11y).
     Deplie = .is-open (max-height + visibility:visible). Simple, fiable, sans requestAnimationFrame. */
  if (filterPanel) filterPanel.hidden = false; // on retire le repli no-JS : le CSS gere desormais l'etat
  function openFilterPanel() {
    if (!filterPanel) return;
    filterPanel.classList.add('is-open');
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'true');
    var first = filterPanel.querySelector('[data-rv-filter]');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
  }
  function closeFilterPanel() {
    if (!filterPanel) return;
    filterPanel.classList.remove('is-open');
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
  }
  function toggleFilterPanel() {
    if (!filterPanel || !filterToggle) return;
    if (filterToggle.getAttribute('aria-expanded') === 'true') { closeFilterPanel(); }
    else { openFilterPanel(); }
  }
  if (filterToggle) filterToggle.addEventListener('click', toggleFilterPanel);

  // chips x (retirent un filtre precis) + reset (retire tout)
  root.addEventListener('click', function (e) {
    var chipX = e.target.closest('[data-rv-chipx]');
    if (chipX) {
      var key = chipX.getAttribute('data-rv-chipx');
      if (key === 'rating' || key === 'size') {
        state[key] = '';
        var sel = root.querySelector('[data-rv-filter="' + key + '"]');
        if (sel) sel.value = '';
        renderList();
      }
      return;
    }
    var reset = e.target.closest('[data-rv-reset]');
    if (reset) {
      state.rating = '';
      state.size = '';
      root.querySelectorAll('[data-rv-filter]').forEach(function (s) { s.value = ''; });
      renderList();
    }
  });

  /* ---------- charger plus ---------- */
  if (moreBtn) moreBtn.addEventListener('click', function () {
    state.revealed = true;
    renderList();
  });

  /* ---------- votes « Utile ? » (visuel) ---------- */
  if (list) list.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rv-up]');
    if (!btn) return;
    var b = btn.querySelector('b');
    if (!b) return;
    var on = !btn.classList.contains('is-on');
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var base = parseInt(btn.getAttribute('data-base'), 10);
    if (isNaN(base)) { base = parseInt(b.textContent, 10) || 0; }
    b.textContent = on ? base + 1 : base;
    var vk = btn.getAttribute('data-vk');
    if (vk) { if (on) { VOTES[vk] = 1; } else { delete VOTES[vk]; } saveVotes(); }
  });

  /* ---------- etoiles « Noter ce produit » ---------- */
  function wireStars(group) {
    if (!group) return;
    var stars = Array.prototype.slice.call(group.querySelectorAll('.rv__ratestar'));
    function paint(v) {
      stars.forEach(function (s) {
        s.classList.toggle('is-on', parseInt(s.getAttribute('data-val'), 10) <= v);
      });
    }
    stars.forEach(function (s) {
      var v = parseInt(s.getAttribute('data-val'), 10);
      s.addEventListener('mouseenter', function () { paint(v); });
      s.addEventListener('focus', function () { paint(v); });
      s.addEventListener('click', function () { group.dataset.value = String(v); paint(v); });
    });
    group.addEventListener('mouseleave', function () { paint(parseInt(group.dataset.value, 10) || 0); });
  }
  var sideStars = root.querySelector('[data-rv-ratestars]');
  var formStars = root.querySelector('[data-rv-formstars]');
  wireStars(sideStars);
  wireStars(formStars);

  /* ---------- ouverture / fermeture formulaire ---------- */
  var form = root.querySelector('[data-rv-form]');
  var thanks = root.querySelector('[data-rv-thanks]');
  var writeToggle = root.querySelector('[data-rv-writetoggle]');
  var cancelBtn = root.querySelector('[data-rv-cancel]');
  var formError = root.querySelector('[data-rv-formerror]');
  var submitBtn = root.querySelector('[data-rv-submit]');

  function showError(msg) {
    if (!formError) return;
    formError.textContent = msg;
    formError.hidden = !msg;
  }

  // ouvre le formulaire (force=true pour les CTA "Donner mon avis" qui ne doivent jamais le refermer)
  function openWriteForm(force) {
    if (!form) return;
    var show = force ? true : form.hasAttribute('hidden');
    form.toggleAttribute('hidden', !show);
    if (thanks) thanks.hidden = true;
    if (show) {
      // la note est saisie via les etoiles "Noter ce produit" (sideStars) -> on amene direct au titre
      var first = form.querySelector('#rvTitle');
      if (first) first.focus();
    }
  }

  if (writeToggle && form) writeToggle.addEventListener('click', function () { openWriteForm(false); });
  // cliquer une etoile "Noter ce produit" revele directement le formulaire (la note est deja capturee par sideStars)
  if (sideStars && form) sideStars.addEventListener('click', function () { openWriteForm(true); });
  // CTA "Donner mon avis" de l'etat vide : ouvre le formulaire (sidebar) + scrolle dessus
  var emptyCta = root.querySelector('[data-rv-emptycta]');
  if (emptyCta && form) emptyCta.addEventListener('click', function () {
    openWriteForm(true);
    var card = root.querySelector('[data-rv-writetoggle]') || form;
    if (card && card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  // deep-link depuis la vue rapide : .../avis-clients?product=...#ecrire-un-avis -> ouvre le formulaire
  if (form && /(^|#)ecrire-un-avis$/.test(location.hash)) {
    setTimeout(function () {
      openWriteForm(true);
      var card = root.querySelector('[data-rv-writetoggle]') || form;
      if (card && card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 300);
  }
  if (cancelBtn && form) cancelBtn.addEventListener('click', function () {
    form.setAttribute('hidden', '');
    showError('');
  });

  /* ---------- soumission reelle ---------- */
  function turnstileToken() {
    try {
      if (window.turnstile && typeof window.turnstile.getResponse === 'function') {
        return window.turnstile.getResponse() || '';
      }
    } catch (e) { /* widget non charge */ }
    return '';
  }

  // pas de worker configure : on garde le formulaire mais on desactive l'envoi
  if (!workerUrl && submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'Envoi bientôt disponible';
  }

  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    showError('');

    if (!workerUrl) {
      showError('L’envoi d’avis sera bientôt disponible.');
      return;
    }

    var rating = parseInt(sideStars && sideStars.dataset.value, 10) || 0;
    var title = (root.querySelector('#rvTitle') || {}).value || '';
    var body = (root.querySelector('#rvText') || {}).value || '';
    var author = (root.querySelector('#rvName') || {}).value || '';
    var size = (root.querySelector('[data-rv-formsize]') || {}).value || '';

    if (rating < 1) { showError('Choisis une note de 1 à 5 étoiles.'); return; }
    if (!author.trim()) { showError('Indique ton nom.'); return; }
    if (!body.trim()) { showError('Écris quelques mots sur le produit.'); return; }

    var token = turnstileToken();
    if (sitekey && !token) { showError('Merci de valider le test anti-robot.'); return; }

    var payload = {
      product_handle: handle,
      author: author.trim(),
      rating: rating,
      title: title.trim(),
      body: body.trim(),
      size: size,
      turnstileToken: token
    };

    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Envoi...'; }

    fetch(workerUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json().catch(function () { return {}; });
      })
      .then(function () {
        form.setAttribute('hidden', '');
        if (thanks) {
          thanks.hidden = false;
          thanks.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        form.reset();
        if (sideStars) {
          delete sideStars.dataset.value;
          sideStars.querySelectorAll('.rv__ratestar').forEach(function (s) { s.classList.remove('is-on'); });
        }
        try { if (window.turnstile && window.turnstile.reset) window.turnstile.reset(); } catch (e) {}
      })
      .catch(function () {
        showError('Une erreur est survenue. Réessaie dans un instant.');
        try { if (window.turnstile && window.turnstile.reset) window.turnstile.reset(); } catch (e) {}
      })
      .finally(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Publier mon avis'; }
      });
  });

  /* ---------- accordeon FAQ sidebar ---------- */
  var faq = root.querySelector('[data-rv-faq]');
  if (faq) faq.addEventListener('click', function (e) {
    var q = e.target.closest('.rv__qq');
    if (!q) return;
    var qa = q.closest('.rv__qa');
    var open = qa.classList.toggle('is-open');
    q.setAttribute('aria-expanded', String(open));
  });

  /* ---------- demarrage ---------- */
  fetchProductMeta();
  fetchReviews();
})();
